import styled from 'styled-components';

export const Container = styled.div`
	div{
		width: 100%;
	}
`;
